import request from "@/utils/request";
//获取销售、采购订单详细信息
export function getContractWithDetailsApi(data) {
  return request({
    url: `/fmsapi/PurchaseManage/GetContractWithDetails`,
    method: "post",
    data,
  });
}
